module.exports = __webpack_public_path__ + "media/images/icons/material/circle-adce0a8f5fbe7ace35c8e05815859a84.svg";